import { DestroyRef, inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InboxService {
  refresh$;
  clear$;

  private refreshSignal$ = new Subject<void>();
  private clearSignal$ = new Subject<void>();

  constructor() {
    this.refresh$ = this.refreshSignal$.asObservable();
    this.clear$ = this.clearSignal$.asObservable();

    inject(DestroyRef).onDestroy(() => {
      this.refreshSignal$.complete();
      this.clearSignal$.complete();
    });
  }

  refresh(): void {
    this.refreshSignal$.next();
  }

  clear(): void {
    this.clearSignal$.next();
  }
}
